import { Fab } from "@mui/material";

interface ClearButtonProps {
  click: () => void;
}

export const ClearButton = ({ click }: ClearButtonProps) => {
  return (
    <Fab
      variant="extended"
      color="warning"
      sx={{ fontWeight: "600" }}
      onClick={click}
    >
      Clear
    </Fab>
  );
};
